import { ChangeDetectionStrategy, Component, inject, Signal, ViewEncapsulation } from '@angular/core';
import { FiQuizHelperService } from '@fi-app/fi-onboarding/fi-quiz/fi-quiz-helper.service';
import { IContentLanguageLabelModel } from '@fi-app/shared/fi-content-language-shared/fi-content-language-shared';
import { FiQuizEditorStoreService } from '../../fi-quiz-editor-store.service';
import { IMediaBankFileReference } from '@fi-app/shared/media-bank';
import { ObjectTypes } from '@fi-shared/types';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { IQuizEditItem } from '../../../fi-quiz';

@Component({
    selector: 'fi-quiz-name-description-card',
    templateUrl: './quiz-name-description-card.component.html',
    styleUrls: ['./quiz-name-description-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-quiz-name-description-card' },
    standalone: false,
    providers: [{ provide: FiComponentsContainer, useExisting: FiQuizNameDescriptionCardComponent }],
})
export class FiQuizNameDescriptionCardComponent extends FiComponentsContainer {
    private fiQuizHelperService = inject(FiQuizHelperService);
    private fiQuizEditorStoreService = inject(FiQuizEditorStoreService);

    protected selectedLanguageId: Signal<number> = this.fiQuizEditorStoreService.selectedLanguageId;
    protected currentQuizData: Signal<IQuizEditItem> = this.fiQuizEditorStoreService.currentQuizData;

    protected onQuizNamesChange(names: IContentLanguageLabelModel[]): void {
        this.fiQuizHelperService.onQuizNamesChange(names);
    }

    protected onQuizDescriptionsChange(descriptions: IContentLanguageLabelModel[]): void {
        this.fiQuizHelperService.onQuizDescriptionsChange(descriptions);
    }

    protected onQuizMediaBankFileReferencesChange(mediaBankFileReferences: IMediaBankFileReference[]): void {
        this.fiQuizHelperService.onQuizMediaBankFileReferencesChange(mediaBankFileReferences);
    }

    protected readonly ObjectTypes = ObjectTypes;
}
